import styled from '@emotion/styled';
import { colors, Stack } from '@ui-components/neo.tax';
import { MenuButton as AriaMenuButton, MenuItem as AriaMenuItem } from 'ariakit';

export const MenuButton = styled(AriaMenuButton)({
  backgroundColor: colors.gray[100],
  height: 36,
  width: 36,
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  borderRadius: 18,
  position: 'relative',
});

export const NotificationBadge = styled.div({
  position: 'absolute',
  top: 2,
  right: 2,
  height: 8,
  width: 8,
  borderRadius: 4,
  backgroundColor: colors.primary[600],
});

export const StyledStack = styled(Stack)({
  maxHeight: '14rem',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: '0 0 0.25rem 0',
  width: 280,
  minHeight: 36,
  borderWidth: 1,
});

export const MenuItem = styled(AriaMenuItem)({
  color: colors.gray[900],
  fontSize: '1rem',
  lineHeight: '1.25rem',
  padding: '0.5rem 1rem',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  overflowX: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
  // From Ariakit: Item currently selected by mouse hover or keyboard
  '&[data-active-item]': {
    backgroundColor: colors.gray[50],
  },
});

export const MenuItemDivider = styled.div({
  margin: '0.1rem 0',
  borderTop: `1px solid ${colors.gray[200]}`,
});

export const NotificationTitle = styled(Stack)({ maxWidth: 200 });
